<template>
<div class="month-container">
  <el-date-picker
    @change="getTimeRange"
    v-model="start"
    type="month"
    placeholder="选择起始月"
    :picker-options="pickerOptions"
    :editable="false"
    :clearable="false">
  </el-date-picker>
  <el-date-picker
    @change="emit"
    v-model="end"
    :editable="false"
    :clearable="false"
    type="month"
    placeholder="选择结束月"
    :picker-options="pickerOptions2">
  </el-date-picker>
</div>
</template>

<script>
const moment = require('moment')
let start = moment().startOf('month').valueOf()

export default {
  name: 'yearTimeSelector',
  data () {
    return {
      date: '',
      start: moment().startOf('month').valueOf(),
      end: moment().endOf('month').valueOf(),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() < start || time.getTime() > Date.now()
        }
      }
    }
  },
  methods: {
    getTimeRange () {
      this.end = moment(this.start).endOf('month').valueOf()
      start = this.start
      this.$emit('input', [moment(this.start).valueOf(), moment(this.end).endOf('month').add(1, 'ms').valueOf()])
    },
    emit () {
      this.$emit('input', [moment(this.start).valueOf(), moment(this.end).endOf('month').add(1, 'ms').valueOf()])
    }
  }
  // created() {
  //   this.getTimeRange()
  // }
}
</script>

<style lang="scss" scoped>
.el-date-editor {
  width: 130px;
}
.month-container {
  display: flex;
  align-items: center;
}
</style>
